import {useNavigate} from "react-router";
import {consumeActionFeedbackNavigation} from "../utils/action-feedback.js";

const BASENAME = import.meta.env.BASE_URL;

const stripTrailingSlash = (url) => (url === "/" ? url : url.replace(/\/+(?=$|[?#])/, ""));

export const navigateHook = () => {
    const navigate = useNavigate();

    return (url, isBlank = false) => {
        const performNavigation = () => {
            if (isBlank) {
                window.open(BASENAME + stripTrailingSlash(url).replace(/^\//, ""));
            } else {
                navigate(stripTrailingSlash(url));
            }
        };

        if (consumeActionFeedbackNavigation()) setTimeout(performNavigation, 1000);
        else performNavigation();
    };
};